import React, {FC} from 'react';

import {AnalyticsPanelId} from '../../../libs/shared/core/src/store/panels/panelStateBase';
import {LiveDashboardContainer} from '../../analytics/components/realTimeReport/liveDashboardContainer';
import {AnalyticsParameters} from '../../store/panels/analytics/parameters/analyticsParameters';
import {Frame} from '../common/frames/frame';

/*
 * Props.
 */

interface PopupLiveDashboardProps {
  panelId: AnalyticsPanelId;
  shouldForcePopout: boolean | undefined;
  parameters: AnalyticsParameters;
  onRequestClose: () => void;
}

/*
 * Component.
 */

export const PopupLiveDashboard: FC<PopupLiveDashboardProps> = ({
  panelId,
  parameters,
  shouldForcePopout,
  onRequestClose,
}) => (
  <Frame
    title="Live dashboard"
    width={900}
    height={670}
    minHeight="570px"
    shouldForcePopout={shouldForcePopout}
    onRequestClose={onRequestClose}
    interactionId="popup-live-dashboard"
  >
    <LiveDashboardContainer panelId={panelId} parameters={parameters} isBetaBannerOpen={false} />
  </Frame>
);
